import { Scenario } from "@/composables/forms/formTypes";
import { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";

export const scenarioHasValidEquipmentBendingStressCalcs = (scenario?: Scenario | null, calcs?: ScenarioCalculations | null) => {
  if(!scenario || !calcs) {
    return false;
  }
  const hasValidDiameters = (
    p?: {
      outer_diameter_inches?: number | null;
      inner_diameter_inches?: number | null;
      neck_outer_diameter_inches?: number | null;
      neck_inner_diameter_inches?: number | null;
    } | null
  ): boolean => {
    if (!p) return false;

    const outerOk =
      typeof p.outer_diameter_inches === "number" &&
      p.outer_diameter_inches > 0;
    const innerOk =
      typeof p.inner_diameter_inches === "number" &&
      p.inner_diameter_inches >= 0;

    const neckOuterOk =
      typeof p.neck_outer_diameter_inches === "number" &&
      p.neck_outer_diameter_inches > 0;
    const neckInnerOk =
      typeof p.neck_inner_diameter_inches === "number" &&
      p.neck_inner_diameter_inches >= 0;
    return outerOk && innerOk && neckOuterOk && neckInnerOk;
  };

  const pumps = calcs?.descendingOrderPumps?.value ?? [];
  const intakes = calcs?.orderedIntakes?.value ?? [];
  const seals = calcs?.descendingOrderSeals?.value ?? [];

  const motor = scenario?.equipment?.r_motor;
  const tubingFt = calcs?.equipmentLengths?.tubingLengthFt?.value ?? 0;

  const hasPump = pumps.length > 0;
  const hasIntake = intakes.length > 0;
  const hasSeal = seals.length > 0;
  const hasMotor = !!motor;
  const hasTubing = tubingFt > 0;

  if (!hasPump || !hasIntake || !hasSeal || !hasMotor || !hasTubing) {
    return false;
  }

  const pumpsOk = pumps.some((pumpItem) => 
    hasValidDiameters({ 
      ...pumpItem.r_pump,
      inner_diameter_inches: pumpItem.r_pump?.housing_inner_diameter_inches,
      outer_diameter_inches: pumpItem.r_pump?.housing_outer_diameter_inches
    })
  )
  const intakesOk = intakes.some((intakeItem) =>
    hasValidDiameters(intakeItem?.r_intake)
  );
  const sealsOk = seals.some((sealItem) =>
    hasValidDiameters(sealItem?.r_seal)
  );
  const motorOk = hasValidDiameters(motor);

  if (!pumpsOk || !intakesOk || !sealsOk || !motorOk) {
    return false;
  }
  return true;

}